export function offsetToBusinessDays(dayOffset: number): number {
  return Math.floor(dayOffset / 7) * 5 + Math.min(dayOffset % 7, 5);
}

export function addBusinessDays(date: Date, days: number): Date {
  const result = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
  
  let dayOfWeek = result.getUTCDay();
  if (dayOfWeek === 0) { // Sunday
    result.setUTCDate(result.getUTCDate() + 1);
    dayOfWeek = 1;
  } else if (dayOfWeek === 6) { // Saturday
    result.setUTCDate(result.getUTCDate() + 2);
    dayOfWeek = 1;
  }
  
  if (days === 0) return result;
  
  const sign = Math.sign(days);
  let remaining = Math.abs(days);
  
  while (remaining > 0) {
    result.setUTCDate(result.getUTCDate() + sign);
    dayOfWeek = result.getUTCDay();
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      remaining--;
    }
  }
  
  return result;
}

export function plannedDateFor(startDate: Date, dayOffset: number): Date {
  const bDays = offsetToBusinessDays(dayOffset);
  return addBusinessDays(startDate, bDays);
}

export function shiftByBusinessDays(date: Date, businessDays: number): Date {
  return addBusinessDays(date, businessDays);
}

export function diffBusinessDays(start: Date, end: Date): number {
  let diff = 0;
  const s = new Date(Date.UTC(start.getUTCFullYear(), start.getUTCMonth(), start.getUTCDate()));
  const e = new Date(Date.UTC(end.getUTCFullYear(), end.getUTCMonth(), end.getUTCDate()));
  
  if (s <= e) {
    const current = new Date(s);
    while (current < e) {
      current.setUTCDate(current.getUTCDate() + 1);
      const day = current.getUTCDay();
      if (day !== 0 && day !== 6) {
        diff++;
      }
    }
  } else {
    const current = new Date(s);
    while (current > e) {
      current.setUTCDate(current.getUTCDate() - 1);
      const day = current.getUTCDay();
      if (day !== 0 && day !== 6) {
        diff--;
      }
    }
  }
  return diff;
}
